import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { colorGuide } from "../../theme/colors";
import { TooltipAppearance } from "./Tooltip.types";

export const ToolTipWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: inherit;
`;

export const TooltipContainer = styled.div<{
  variant: string;
  $appearance?: TooltipAppearance;
}>`
  position: absolute;
  max-width: ${({ $appearance }) =>
    $appearance === "light" ? "none" : "228px"};
  cursor: pointer;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  z-index: 1000;

  flex-direction: ${(props) =>
    props.variant === "left" || props.variant === "right" ? "row" : "column"};

  ${({ variant }) =>
    variant === "top" &&
    `
      top: calc(100% + 8px);
      left: 50%;
      transform: translateX(-50%);
    `}

  ${({ variant }) =>
    variant === "bottom" &&
    `
      bottom: calc(100% + 8px);
      left: 50%;
      transform: translateX(-50%);
    `}

  ${({ variant }) =>
    variant === "left" &&
    `
     left: calc(100% + 8px);
      top: 50%;
      transform: translateY(-50%);
    `}

  ${({ variant }) =>
    variant === "right" &&
    `
      right: calc(100% + 8px);
      top: 50%;
      transform: translateY(-50%);
    `}
`;

export const TooltipBodyWrapper = styled.div`
  position: relative;
  display: flex;
`;

export const LightTooltipBeak = styled.div`
  position: absolute;
  top: -5px;
  left: 50%;
  width: 8px;
  height: 8px;
  background: #ffffff;
  border-left: 1px solid #e0e0e0;
  border-top: 1px solid #e0e0e0;
  transform: translateX(-50%) rotate(45deg);
  z-index: 1;
`;

export const TooltipTextContainer = styled.div<{
  $appearance?: TooltipAppearance;
}>`
  display: flex;
  box-sizing: border-box;
  flex: 1 0 0;

  ${({ $appearance }) =>
    $appearance === "light"
      ? css`
          position: relative;
          padding: 8px 12px;
          justify-content: flex-start;
          align-items: flex-start;
          gap: 0;
          border-radius: 8px;
          background-color: #ffffff;
          border: 1px solid #e0e0e0;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
          width: 283px;
          max-width: min(283px, calc(100vw - 40px));
          min-width: 0;
          white-space: normal;
          word-break: break-word;
        `
      : css`
          padding: 8px;
          justify-content: center;
          align-items: center;
          gap: 10px;
          border-radius: 4px;
          background-color: ${colorGuide.lightComponents.toolTip.bgColor};
          width: max-content;
          height: 100%;
          max-width: 228px;
        `}
`;

export const IconContainer = styled.img<{
  variant: string;
}>`
  width: ${(props) =>
    props.variant === "left" || props.variant === "right" ? "12px" : "20px"};
  height: ${(props) =>
    props.variant === "left" || props.variant === "right" ? "20px" : "12px"};
  flex-shrink: 0;
  transform: ${({ variant }) =>
    variant === "left"
      ? "rotate(180deg)"
      : variant === "bottom"
      ? "rotate(180deg)"
      : "none"};
`;
